import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../styles/footer.css'
import logoBlack from '../images/logo-black.png'

//font awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faGooglePlusG } from '@fortawesome/free-brands-svg-icons'

export class Footer extends Component {
    render() {
        return (
            <div>
                <section className="footer bg-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 brand-footer-div">
                                <img src={logoBlack} alt="" />
                                <p className="copyright-text">COPYRIGHT © 2020, Development Team</p>
                            </div>
                            <div className="col-lg-3 col-sm-2 col-xs-3 connect-div">
                                <h3>CONNECT</h3>
                                <ul>
                                    <li>
                                        <Link to="/email"><FontAwesomeIcon icon={faEnvelope} />devteam@ipark.com</Link>
                                    </li>
                                    <li>
                                        <Link><FontAwesomeIcon icon={faFacebook} />facebook</Link>
                                    </li>
                                    <li>
                                        <Link><FontAwesomeIcon icon={faInstagram} />instagram</Link>
                                    </li>
                                    <li>
                                        <Link><FontAwesomeIcon icon={faGooglePlusG} />google+</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default Footer
